import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import axios from 'axios'
import {useGlobalStore} from '@/stores/index';
import {useCableConfiguratorStore} from '@/stores/cableConfigurator';
import {i18n} from '@/plugins/i18n';

export const useCartStore = defineStore('cart', () =>
{
    const items = ref([])
    const overlay = ref(false)
    const hint = ref(false)
    const sampleArr = ref([])
    const loading = ref(false)
    const submitted = ref(false)
    const noresultSubmitted = ref(false)
    const success = ref(false)
    const noresultSuccess = ref(false)
    const openedFirstTime = ref(false)
    const savedCableConfigHint = ref(false)
    const cableInCartHint = ref(false)
    const removeHint = ref(false)
    const enabledForm = ref(false)

    const globalStore = useGlobalStore()
    const cableConfigurationStore = useCableConfiguratorStore()

    const noresultsForm = ref({
        email: '',
        zip: '',
        company: '',
        country: '',
        text: '',
        multiselect: [],
        search: '',
        grecaptchaTokenForms: ''
    })

    const form = ref({
        salutation: '',
        firstname: '',
        lastname: '',
        company: '',
        country: '',
        address: '',
        zip: '',
        city: '',
        phone: '',
        email: '',
        message: i18n.global.t('overlay.form.messageDefault'),
        privacy: false,
        grecaptchaTokenForms: ''
    })

    function init ()
    {
        let ls = window.localStorage
        if (ls.getItem('partnumber-cart'))
        {
            items.value = JSON.parse(ls.getItem('partnumber-cart'))
        } else
        {
            items.value = []
        }
    }

    function removeAll ()
    {
        items.value = []
        storeInLocalStorage()
    }

    function openHint () {
        if (openedFirstTime.value === false)
        {
            openedFirstTime.value = true
            overlay.value = true
        }
    }

    function storeInLocalStorage()
    {
        let ls = window.localStorage
        let mappedItems = items.value.map(item =>
        {
            return {
                id: item.id,
                cableConfigLength: item.cableConfigLength,
                hidePartNo: item.hidePartNo,
                express: item.express,
                description: item.description,
                freeSample: item.freeSample,
                image: item.image,
                type: item.type,
                series: item.series,
                cableConfigurationAvailable: item.cableConfigurationAvailable ? item.cableConfigurationAvailable : '',
                cableConfigBend: item.cableConfigBend ? item.cableConfigBend : '',
                cableConfigCountNo: item.cableConfigCountNo ? item.cableConfigCountNo : '',
            }
        })
        ls.setItem('partnumber-cart', JSON.stringify(mappedItems))
    }

    function addToCart (item, force = false) {
        if (item.typeKey === 'cable_assembly' && item.assemblyId)
        {
            if (item.cableConfigLength)
            {
                items.value.push(item)
                storeInLocalStorage()
                cableConfigurationStore.showOverlay = false
                cableConfigurationStore.scrollToCableConfi = false
                openHint()
            } else {
                cableConfigurationStore.showOverlay = true
                cableConfigurationStore.scrollToCableConfi = true
            }

        } else {
            if (item.cableConfigurationAvailable && !force)
            {
                cableConfigurationStore.availableCableConfiHint = true
            } else {
                items.value.push(item)
                storeInLocalStorage()
                openHint()
            }
        }

    }

    function removeFromCart (item, key = null) {
      if (key || key === 0)
      {
        items.value.splice(key, 1)
        storeInLocalStorage()
      } else {
        const idx = items.value.map(el => el.id).indexOf(item.id)
        const count = items.value.filter(el => el.id === item.id).length
        if (count > 1)
        {
          removeHint.value = true
          overlay.value = true
        } else {
          if (idx > -1)
          {
            items.value.splice(idx, 1)
            storeInLocalStorage()
          }
        }
      }


    }

    function itemInCart (item) {
        return items.value.filter(el => el.id === item.id).length
    }

    const productString = computed(() =>
    {
        let pString = ''
        items.value.forEach(element =>
        {
            let url = new URL(window.location.origin + window.location.pathname + '#/show/' + element.id)
            if (element.cableConfigLength) {
                pString += element.description + ' / Part number: ' + element.id + globalStore.fillUpLength(element.cableConfigLength) + ' ' + url + '%0D%0A%0D%0A'
            } else {
                pString += element.description + ' / Part number: ' + element.id + ' ' + url + '%0D%0A%0D%0A'
            }
        })
        return pString
    })

    function submitForm () {
        loading.value = true
        const action = 'odu_forms_form',
            localGrecaptcha = window.grecaptcha
        localGrecaptcha.ready(() =>
        {
            localGrecaptcha.execute(window.tx_theme.constants.googlerecaptcha.public_key, { action })
                .then(token =>
                {
                    const url = new URL(window.app.partnumber_search_extended.mail_api_base + 'mail/partnumber-request/')
                    const samples = sampleArr.value.map(el => el.value).toString()
                    const productsString = items.value.map(el => el.id).toString()
                    const products = []
                    items.value.forEach(element =>
                    {
                        let elementString = element.id

                        elementString += ' | Type: ' + element.type

                        if (element.series && element.series[0])
                        {
                            elementString += ' | Series: ' + element.series[0]
                        }
                        if (element.express)
                        {
                            elementString += ' | Express'
                        } else {
                            elementString += ' | -'
                        }
                        if (element.cableConfigLength)
                        {
                            elementString += ' | Cableconfig length:' + globalStore.fillUpLength(element.cableConfigLength)
                        }
                        products.push(elementString)
                    })

                    if (window.dataLayer) {
                        window.dataLayer.push({
                            'product-request': productsString,
                            'event': 'product-request-event'
                        })
                    }

                    url.searchParams.set('tx_api_api[date]', new Date())
                    url.searchParams.set('tx_api_api[salutation]', form.value.salutation)
                    url.searchParams.set('tx_api_api[firstname]', form.value.firstname)
                    url.searchParams.set('tx_api_api[lastname]', form.value.lastname)
                    url.searchParams.set('tx_api_api[company]', form.value.company)
                    url.searchParams.set('tx_api_api[country]', form.value.country)
                    url.searchParams.set('tx_api_api[address]', form.value.address)
                    url.searchParams.set('tx_api_api[zip]', form.value.zip)
                    url.searchParams.set('tx_api_api[city]', form.value.city)
                    url.searchParams.set('tx_api_api[phone]', form.value.phone)
                    url.searchParams.set('tx_api_api[email]', form.value.email)
                    url.searchParams.set('tx_api_api[message]', form.value.message)
                    url.searchParams.set('tx_api_api[privacy]', form.value.privacy)
                    url.searchParams.set('tx_api_api[grecaptchaTokenForms]', token)
                    url.searchParams.set('tx_api_api[freeSamples]', samples)
                    url.searchParams.set('tx_api_api[products]', products)
                    axios.post(url)
                        .then(response => {
                            success.value = response.data.status === 200
                            loading.value = false
                            submitted.value = true
                            items.value = []
                            storeInLocalStorage()
                        })
                        .catch(() => {
                            loading.value = false
                            success.value = false
                            submitted.value = true
                        })
                })
        })




    }

    function submitNoresultForm () {
        loading.value = true
        const action = 'odu_forms_form',
            localGrecaptcha = window.grecaptcha
        localGrecaptcha.ready(() =>
        {
            localGrecaptcha.execute(window.tx_theme.constants.googlerecaptcha.public_key, { action })
                .then(token =>
                {
                    const url = new URL(window.app.partnumber_search_extended.mail_api_base + 'mail/noresult-request/')

                    url.searchParams.set('tx_api_api[email]', noresultsForm.value.email)
                    url.searchParams.set('tx_api_api[zip]', noresultsForm.value.zip)
                    url.searchParams.set('tx_api_api[company]', noresultsForm.value.company)
                    url.searchParams.set('tx_api_api[country]', noresultsForm.value.country)
                    url.searchParams.set('tx_api_api[multiselect]', noresultsForm.value.multiselect)
                    url.searchParams.set('tx_api_api[text]', noresultsForm.value.text)
                    url.searchParams.set('tx_api_api[search]', noresultsForm.value.search)
                    url.searchParams.set('tx_api_api[grecaptchaTokenForms]', token)
                    axios.post(url)
                        .then(response => {
                            noresultSuccess.value = response.data.status === 200
                            loading.value = false
                            noresultSubmitted.value = true
                        })
                        .catch(() => {
                            loading.value = false
                            noresultSuccess.value = false
                            noresultSubmitted.value = true
                        })
                })
        })




    }

    return {
        items,
        overlay,
        hint,
        sampleArr,
        form,
        noresultsForm,
        addToCart,
        itemInCart,
        removeFromCart,
        submitForm,
        submitNoresultForm,
        loading,
        submitted,
        noresultSubmitted,
        success,
        noresultSuccess,
        openedFirstTime,
        productString,
        savedCableConfigHint,
        cableInCartHint,
        removeHint,
        enabledForm,
        init,
        removeAll
    }
})
